import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateClientPortalConfigMutation($input: UpdateClientPortalConfigInput!) {
		updateClientPortalConfig(input: $input) {
			clientPortalConfig {
				portalActive
				portalLogoUrl
				portalPrimaryColour
				portalSenderName
				showInvoices
				allowFileUpload
				showRetainer
				showComments
				hideTimeEntries
				hideEstimates
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
